import { Button, showToast } from "@emdur/ui";

/** Public key identifiers stay intact; their existing kit action copies the full value. */
export function PublicKeyIds({ keys }: { keys: Record<string, unknown>[] }) {
  return (
    <ul className="min-w-0 space-y-1">
      {keys.map((key, index) => {
        const id = typeof key.kid === "string" ? key.kid : "";
        return (
          <li key={index} className="min-w-0">
            {id ? (
              <Button
                variant="quiet"
                size="sm"
                aria-label={`Copy key id ${id}`}
                onPress={async () => {
                  try {
                    await navigator.clipboard.writeText(id);
                    showToast({ title: "Key id copied", tone: "positive" });
                  } catch {
                    showToast({
                      title:
                        "The key id could not be copied. Try again when clipboard access is available.",
                      tone: "warning",
                    });
                  }
                }}
              >
                <span className="block max-w-40 truncate" title={id}>
                  {id}
                </span>
              </Button>
            ) : (
              <span className="text-sm text-muted">Unnamed key</span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
